module.exports = __webpack_public_path__ + "static/media/locate.ba99e8db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Location/assets/locate.svg
// module id = 470
// module chunks = 0